module.exports = __webpack_public_path__ + "img/button-home5.f81bc8a9.jpeg";